// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WindowsOutlinedSvg from "@ant-design/icons-svg/es/asn/WindowsOutlined";
import AntdIcon from '../components/AntdIcon';

var WindowsOutlined = function WindowsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WindowsOutlinedSvg
  }));
};

WindowsOutlined.displayName = 'WindowsOutlined';
export default React.forwardRef(WindowsOutlined);